var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { FieldContextKey, useFieldError, useIsFieldTouched, useIsFieldDirty, useIsFieldValid } from "vee-validate";
import { inject } from "vue";
import { FORM_ITEM_INJECTION_KEY } from "../injectionKeys.js";
function useFormField() {
  const fieldContext = inject(FieldContextKey), fieldItemContext = inject(FORM_ITEM_INJECTION_KEY, "_");
  if (!fieldContext)
    throw new Error("useFormField should be used within <FormField>");
  const { name } = fieldContext, fieldState = {
    valid: useIsFieldValid(name),
    isDirty: useIsFieldDirty(name),
    isTouched: useIsFieldTouched(name),
    error: useFieldError(name)
  };
  return {
    id: fieldItemContext,
    name,
    formItemId: `${fieldItemContext}-form-item`,
    formDescriptionId: `${fieldItemContext}-form-item-description`,
    formMessageId: `${fieldItemContext}-form-item-message`,
    ...fieldState
  };
}
__name(useFormField, "useFormField");
export {
  useFormField
};
//# sourceMappingURL=useFormField.js.map
